declare namespace $ {

	type $mol_text__text_shm_file_drop_1 = $mol_type_enforce<
		ReturnType< $shm_file_drop['drop_title'] >
		,
		ReturnType< $mol_text['text'] >
	>
	export class $shm_file_drop extends $mol_button_open {
		drop_title( ): string
		Label( ): $mol_text
		drag_active( next?: boolean ): boolean
		drag_enter( next?: any ): any
		drag_over( next?: any ): any
		drag_leave( next?: any ): any
		file_drop( next?: any ): any
		multiple( ): boolean
		title( ): ReturnType< $shm_file_drop['drop_title'] >
		sub( ): readonly(any)[]
		attr( ): ({ 
			'shm_file_drop_drag': ReturnType< $shm_file_drop['drag_active'] >,
		})  & ReturnType< $mol_button_open['attr'] >
		event( ): ({ 
			dragenter( next?: ReturnType< $shm_file_drop['drag_enter'] > ): ReturnType< $shm_file_drop['drag_enter'] >,
			dragover( next?: ReturnType< $shm_file_drop['drag_over'] > ): ReturnType< $shm_file_drop['drag_over'] >,
			dragleave( next?: ReturnType< $shm_file_drop['drag_leave'] > ): ReturnType< $shm_file_drop['drag_leave'] >,
			drop( next?: ReturnType< $shm_file_drop['file_drop'] > ): ReturnType< $shm_file_drop['file_drop'] >,
		})  & ReturnType< $mol_button_open['event'] >
	}
	
}

//# sourceMappingURL=drop.view.tree.d.ts.map